"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanStackTrace = void 0;
function cleanStackTrace(err) {
    err.stack = clean(err.stack);
}
exports.cleanStackTrace = cleanStackTrace;
function clean(errStack) {
    if (!errStack) {
        return errStack;
    }
    var errStackCleaned = splitByLine(errStack)
        .filter(function (line) {
        // Remove stack traces related to this package
        if (/@brillout.assert/.test(line)) {
            return false;
        }
        // Remove useless internal stack traces
        if (line.includes(" (internal/")) {
            return false;
        }
        return true;
    })
        .join("\n");
    return errStackCleaned;
}
function splitByLine(str) {
    // https://stackoverflow.com/questions/21895233/how-in-node-to-split-string-by-newline-n
    return str.split(/\r?\n/);
}
//# sourceMappingURL=manipulateStackTrace.js.map